/* eslint-disable no-param-reassign */
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Notification,
  Grid,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from '@xbotvn/mui';
import {
  get,
  toLower,
  replace,
} from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';
import { useSelector } from 'react-redux';

import YouTubeStudioWarning from '../../../components/YouTubeStudioWarning';
import {
  convertYoutubeStudioUrl,
  getThumbnail,
  normalizeText,
} from '../../../libs/utils';

const getCoverFallback = (data) => data?.coverLink || '/defaultBook.jpg';
const parseTags = (value = '') => value
  .split(',')
  .map((tag) => tag.trim())
  .filter(Boolean);
const joinTags = (tags) => (Array.isArray(tags) ? tags.join(', ') : '');

export default function Editor({
  onHandler = () => { },
  data: initData = {},
  onClose,
}) {
  const [data, setData] = useState({
    ...initData,
    shareToChildren: typeof initData?.shareToChildren === 'boolean'
      ? initData.shareToChildren
      : true,
  });
  const [tagsInput, setTagsInput] = useState(joinTags(initData?.tags));
  const [studioUrlDialog, setStudioUrlDialog] = useState();

  const unitInfo = useSelector(({ user, unit }) => unit.data?.[user?.activeUnit]);

  const isParent = unitInfo?.type === 'department';

  useEffect(() => {
    setTagsInput(joinTags(initData?.tags));
  }, [initData]);

  return (
    <>
      <YouTubeStudioWarning
        open={!!studioUrlDialog}
        studioUrlDialog={studioUrlDialog}
        onClose={() => setStudioUrlDialog(null)}
        onConvert={(url) => {
          setData((prevData) => ({
            ...prevData,
            bookLink: url,
          }));
        }}
      />
      <Dialog maxWidth="lg" fullWidth open onClose={onClose}>
        <DialogTitle onClose={onClose}>{`${initData?._id ? 'Sửa' : 'Thêm'} sách trực tuyến`}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <img
                style={{ objectFit: 'fill' }}
                width="100%"
                height="100%"
                src={getCoverFallback(data)}
                srcSet={getCoverFallback(data)}
                alt={data?.name}
                loading="lazy"
              />
            </Grid>
            <Grid item xs={7}>
              <TextField
                label="Nhan đề sách"
                value={get(data, 'name', '')}
                onChange={(e) => {
                  setData((prevData) => ({
                    ...prevData,
                    name: e.target.value,
                  }));
                }}
                required
              />
              <TextField
                fullWidth
                label="Phụ đề sách"
                value={get(data, 'subtitle', '')}
                onChange={(e) => {
                  setData((prevData) => ({
                    ...prevData,
                    subtitle: e.target.value,
                  }));
                }}
              />
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="Đường link bìa sách"
                    value={get(data, 'coverLink', '')}
                    onChange={(e) => {
                      const coverLink = getThumbnail(e.target.value);
                      setData((prevData) => ({
                        ...prevData,
                        coverLink,
                      }));
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Đường link sách"
                    value={get(data, 'bookLink', '')}
                    onChange={(e) => {
                      const url = e.target.value;
                      setData((prevData) => ({
                        ...prevData,
                        bookLink: url,
                      }));
                      const studioData = convertYoutubeStudioUrl(url);
                      if (studioData) {
                        setStudioUrlDialog(studioData);
                      }
                    }}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6} display="flex" alignItems="center" flexDirection="column">
                  <Tooltip
                    title="Khi tick công khai phụ huynh có thể xem sách tại trang Sách trực tuyến mà không cần đăng nhập"
                    placement="top"
                  >
                    <div style={{ alignSelf: 'flex-start' }}>
                      <FormControlLabel
                        control={(
                          <Checkbox
                            checked={get(data, 'isPublic', false)}
                            onChange={(e) => setData((prevData) => ({
                              ...prevData,
                              isPublic: e.target.checked,
                            }))}
                            color="primary"
                          />
                        )}
                        label="Công khai"
                      />
                    </div>
                  </Tooltip>
                  {data.isPublic ? (
                    <Button
                      size="small"
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        const normalizeStr = replace(normalizeText(toLower(unitInfo?.name || '')), / /g, '_');
                        window.open(`${window.location.origin}/sachTrucTuyen/${normalizeStr}/${data.unitId}`, '_blank');
                      }}
                      style={{ marginTop: 5, alignSelf: 'flex-start' }}
                    >
                      Link công khai
                    </Button>
                  ) : null}
                </Grid>
                <Grid item xs={6} display="flex" alignItems="center">
                  {isParent && (
                    <FormControlLabel
                      control={(
                        <Checkbox
                          checked={get(data, 'shareToChildren', true)}
                          onChange={(e) => setData((prevData) => ({
                            ...prevData,
                            shareToChildren: e.target.checked,
                          }))}
                          color="primary"
                        />
                      )}
                      label="Chia sẻ cho trường trực thuộc"
                    />
                  )}
                </Grid>
              </Grid>
              {/* <TextField
                fullWidth
                label="Đường link vị trí sách"
                value={get(data, 'positionLink', '')}
                onChange={(e) => {
                  let positionLink = e.target.value;
                  if (includes(positionLink, 'drive.google.com/file/d/')) {
                    positionLink = convertGGDriveUrl(positionLink);
                  }
                  setData((prevData) => ({
                    ...prevData,
                    positionLink,
                  }));
                }}
              /> */}
              <TextField
                fullWidth
                label="Tags (phân tách bằng dấu phẩy)"
                value={tagsInput}
                onChange={(e) => setTagsInput(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => {
              const {
                name,
                bookLink,
              } = data;
              if (!name) {
                Notification.warn('Nhan đề không được bỏ trống.');
                return;
              }
              if (!bookLink) {
                Notification.warn('Đường link sách online không được bỏ trống.');
                return;
              }
              const tags = parseTags(tagsInput);
              onHandler({
                ...data,
                tags,
              });
            }}
          >
            Lưu
          </Button>
          <Button color="warning" onClick={onClose}>
            Huỷ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

Editor.propTypes = {
  data: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onHandler: PropTypes.func,
};
